// extracted by mini-css-extract-plugin
export default {"addToCartControl":"d3-z","giftCard":"e3-z","btnContainer":"f3-z","cartButton":"g3-z","disabled":"h3-z","stockMessage":"i3-z"};